import React, { Component } from 'react';
import axios from 'axios';
import style from './style.scss';
import CONFIG from '../../config';

import LaddaButton from '../ladda-button';

export default class EmailInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      loading: false,
      message: 'Submit'
    };
  }

  submit() {
    this.setState({ loading: true });

    axios.post(`${CONFIG.baseUrl}/api/signup`, {
      email: this.state.value
    }, {
      headers: {'Content-Type': 'application/json'}
    })
    .then((response) => {
      window.setTimeout(::this.resetState, 2000);
      this.setState({
        loading: false,
        message: 'Success!'
      });
    })
    .catch((error) => {
      window.setTimeout(::this.resetState, 2000);
      this.setState({
        loading: false,
        message: 'Error!'
      });
    });
  }

  resetState() {
    this.setState({
      value: '',
      loading: false,
      message: 'Submit'
    });
  }

  wrapperStyling() {
    return this.props.inFooter ? "emailInputWrapper" : "";
  }

  handleChange = (event) => {
    this.setState({value: event.target.value});
  }

  render() {
    return (
      <div className={this.wrapperStyling()} >
        <p className="emailInputText">Join the Beta for the Kratos iOS app</p>
        <div className="emailInputContainer">
          <div className="emailInputGroup">
            <input required type="text" value={this.state.value} onChange={this.handleChange}/>
            <span className="emailInputHighlight"></span>
            <span className="emailInputBar"></span>
            <label>Email</label>
          </div>
          <div>
            <LaddaButton loading={this.state.loading} onSubmit={::this.submit} disabled={!this.state.value.length > 0}>
              {this.state.message}
            </LaddaButton>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/email-input/index.js